import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import 'aos/dist/aos.css';
import AOS from 'aos';
import './Services.css';
import VoipServices from "./VoipServices";
import DedicatedChannels from "./DedicatedChannels";
import AdditionalServices from "./AdditionalServices";
import Meta from './Meta';

export function Services() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
      <React.Fragment>
      <Meta
         title="Услуги провайдера - ит особа"
         description="Выгодные предложения на интернет для физических и юридических лиц, услуги видеонаблюдения, виртуальные офисы, аутсорсинг, телефония, выделенные каналы связи, облачное хранение данных, проектирование СКС и многое другое от it osoba (Москва, Московская область, Подольск, Домодедово, Климовск, Кучино, Северово, Стрелково, Остафьево, Щербинка, Знамя Октября, Старосырово, Борисовка и т.д.)"
       />
      <div className="buttons-container container2" style={{display: 'flex', gap: '20px'}}>
          <Link to="/fiz-lico" className="button-card2" data-aos="zoom-in" data-aos-delay="100" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
              <h3>Интернет городской (для физических лиц)</h3>
              <p>Мы предлагаем вам выгодные пакеты неограниченного доступа к
                  Глобальной Сети </p>
          </Link>
          <Link to="/business" className="button-card2" data-aos="zoom-in" data-aos-delay="200" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
              <h3>Интернет для бизнеса (юридических лиц)</h3>
              <p>Оператор быстрого подключения "ИТ Особа" предлагает оптимальные пакеты для подключения офисов и
                  организаций</p>
          </Link>
          <Link to="/private-sector" className="button-card2" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
              <h3>Интернет для частного сектора</h3>
              <p>Компания "ИТ Особа" предлагает подключение в частных домах и коттеджах.
                  Вы получите быстрый и качественный интернет!</p>
          </Link>
          <Link to="/video" className="button-card2" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
              <h3>Установка видеонаблюдения</h3>
              <p>Мы предлагаем установку видеонаблюдения на любых объектах</p>
          </Link>
          <Link to="/virtual_office" className="button-card2" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
              <h3>Виртуальные рабочие места (DaaS)</h3>
              <p>"ИТ Особа" предлагает решение по созданию инфраструктуры виртуальных рабочих столов,
                  обеспечивающее сотрудникам удалённый доступ к сетевому окружению и полному набору необходимых приложений</p>
          </Link>
          <Link to="/outsourcing" className="button-card2" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
              <h3>Аутсорсинг системного администрирования</h3>
              <p>Эффективный и экономичный аутсорсинг IT-услуг от "ИТ Особа"</p>
          </Link>
          <Link to="/voip_services" className="button-card2" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
              <h3>Подключение телефонии</h3>
              <p>Мы предлагаем услуги VoIP-телефонии и виртуальной АТС</p>
          </Link>
          <Link to="/dedicated_channels" className="button-card2" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
              <h3>Выделенные каналы связи для вашего бизнеса</h3>
              <p>"ИТ Особа" предлагает стабильную, быструю и защищенную связь</p>
          </Link>
          <Link to="/cloud_storage" className="button-card2" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
              <h3>Облачное хранение данных</h3>
              <p>Мы предлагаем надежное, масштабируемое и безопасное облачное хранение данных</p>
          </Link>
          <Link to="/structured_network" className="button-card2" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
              <h3>Проектирование и установка СКС от "ИТ Особа"</h3>
              <p>Мы предлагаем надежное создание современной инфраструктуры</p>
          </Link>
          <Link to="/additional_services" className="button-card2" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
              <h3>Дополнительные услуги</h3>
              <p>"ИТ Особа" предлагает аренду ВОЛС, оптических лямбд, VLAN, L2VPN, Q in Q, MTU, QoS, корпоративный VPN, публичный Wi-Fi</p>
          </Link>
      </div>
      </React.Fragment>
  );
}